/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener("DOMContentLoaded", () => {
  const beacon = document.querySelector("#hs-beacon");
  if (beacon) {
    beacon.addEventListener("mouseover", () => {
      loadBeacon();
    });

    beacon.addEventListener("touchstart", () => {
      loadBeacon();
    }, { passive: !0 });

    beacon.addEventListener("click", () => {
      window.Beacon("open");
      beacon.style.zIndex = 1000;
      beacon.style.opacity = 0;
    });
  }

  function loadBeacon() {
    if (typeof window.Beacon == "undefined") {
      var script = document.createElement("script");
      script.id = "beacon";
      script.text = `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`;
      document.head.appendChild(script);

      window.Beacon("init", "1430bc31-60b7-4e8c-b67a-675cb031dfc6");
    }
  }

  // Event listener for the footer link
  document.addEventListener("click", (e) => {
    if (e.target.tagName === 'A' && e.target.getAttribute("href") === "#hs-beacon") {
      e.preventDefault(); // Prevent the default action
      loadBeacon();
      setTimeout(() => {
        window.Beacon("open");
        if (beacon) {
          beacon.style.zIndex = 1000;
          beacon.style.opacity = 0;
        }
      }, 500); // Give some time for the script to load and initialize
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  
  document.querySelectorAll('.quick-links').forEach(function(quickLinks) {
    var savedPosition = sessionStorage.getItem('scrollPosition');
    
    // Check if scrolling is possible
    var canScroll = quickLinks.scrollWidth > quickLinks.clientWidth;
    
    // Save new scroll position on scroll
    quickLinks.addEventListener('scroll', function() {
      sessionStorage.setItem('scrollPosition', quickLinks.scrollLeft);
    });

    // Function to check if an element is in view
    function isInView(container, element) {
      const containerLeft = container.scrollLeft;
      const containerRight = containerLeft + container.clientWidth;
      const elementLeft = element.offsetLeft;
      const elementRight = elementLeft + element.clientWidth;
      
      return elementLeft >= containerLeft && elementRight <= containerRight;
    }

    // Get the active link
    const activeLink = quickLinks.querySelector('.quick-links-item.is-active');

    // If there's a saved position and scrolling is possible
    if(savedPosition && canScroll) {
      quickLinks.scrollLeft = savedPosition;

      // If the active link is not in view after scrolling to saved position
      if(!isInView(quickLinks, activeLink)) {
        // Calculate the position to center the active link
        let centerPosition = activeLink.offsetLeft + (activeLink.clientWidth / 2) - (quickLinks.clientWidth / 2);
        
        // Adjust for beginning and end of the list
        centerPosition = Math.max(centerPosition, 0);
        centerPosition = Math.min(centerPosition, quickLinks.scrollWidth - quickLinks.clientWidth);
        
        quickLinks.scrollLeft = centerPosition;
      }
    } else if (activeLink && canScroll) {
      // If there's no saved position but there's an active link
      let centerPosition = activeLink.offsetLeft + (activeLink.clientWidth / 2) - (quickLinks.clientWidth / 2);
      
      // Adjust for beginning and end of the list
      centerPosition = Math.max(centerPosition, 0);
      centerPosition = Math.min(centerPosition, quickLinks.scrollWidth - quickLinks.clientWidth);
      
      quickLinks.scrollLeft = centerPosition;
    }
  });
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// navigate-next.js
const navigateNextButton = document.querySelector('[data-action="navigate-next"]');

if (navigateNextButton) {
  navigateNextButton.addEventListener('click', function() {
    const nextSection = this.closest(".shopify-section").nextElementSibling;
    if (nextSection) {
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
      const targetPosition = nextSection.getBoundingClientRect().top + window.pageYOffset - headerHeight + 20;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      });
    }
  });
}

/**
 * Native Klaviyo Back in Stock form.
 *
 * The theme's x-modal component provides a side drawer on desktop and a bottom
 * sheet on mobile. Klaviyo's client endpoint only needs the shopper email and
 * the selected Shopify variant ID, so no private API key is exposed here.
 */
class BackInStock extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.productForm = document.forms[this.dataset.productForm];
    this.modal = this.querySelector('x-modal');
    if (this.modal) this.modal.backInStockComponent = this;
    this.form = this.querySelector('[data-back-in-stock-form]');
    this.emailInput = this.form?.querySelector('input[type="email"]');
    this.message = this.querySelector('[data-back-in-stock-message]');
    this.messageText = this.querySelector('[data-back-in-stock-message-text]');
    this.successIcon = this.querySelector('[data-back-in-stock-success-icon]');
    this.fallbackLink = this.querySelector('[data-back-in-stock-fallback]');
    this.submitButton = this.form?.querySelector('button[type="button"]');
    this.productName = this.querySelector('[data-back-in-stock-product]');
    this.variantName = this.querySelector('[data-back-in-stock-variant]');
    this.variantImage = this.querySelector('[data-back-in-stock-image]');
    this.variants = this.getVariants();
    this.variant = this.getVariant(this.dataset.initialVariantId) || {
      id: this.dataset.initialVariantId,
      available: this.dataset.initialVariantAvailable === 'true'
    };

    if (!this.productForm || !this.modal || !this.form || !this.emailInput || !this.submitButton) return;

    // The theme event is the normal integration point. The ID-input change
    // listener is a fallback that updates immediately even when app code
    // changes the selector without forwarding the custom event.
    this.productForm.addEventListener('variant:change', (event) => {
      this.updateVariant(event.detail?.variant || this.getVariantFromForm());
    });
    this.productForm.addEventListener('change', (event) => {
      if (event.target.name === 'id') this.updateVariantById(event.target.value);
    });
    this.bindTriggers();
    this.submitButton.addEventListener('click', (event) => this.submit(event));
    // Clear the email and feedback when the sheet closes so a later variant
    // selection always starts with a clean form.
    this.modal.addEventListener('dialog:after-hide', () => this.resetForm());
    this.updateVariant(this.variant);
  }

  // Triggers live outside this element (the sticky bar renders after it, and a section re-render replaces the nodes),
  // so they are resolved on every update rather than captured once at connect time.
  get triggers() {
    return Array.from(document.querySelectorAll('[data-back-in-stock-trigger]')).filter(
      (trigger) => trigger.getAttribute('aria-controls') === this.modal?.id
    );
  }

  get addToCartButtons() {
    return Array.from(document.querySelectorAll(`buy-buttons[form="${this.dataset.productForm}"] button[type="submit"]`));
  }

  bindTriggers() {
    const triggers = this.triggers;

    triggers.forEach((trigger) => {
      if (trigger.backInStockBound) return;
      trigger.backInStockBound = true;

      // x-modal also has delegated aria-controls handling. This direct listener runs in the target phase, ahead of
      // that delegate, so stopping propagation here keeps the modal from being toggled straight back closed.
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.modal.show();
      });
    });

    return triggers;
  }

  updateVariant(variant) {
    const changedVariant = this.variant?.id !== variant?.id;
    this.variant = variant || null;

    const triggers = this.bindTriggers();
    const isSoldOut = Boolean(this.variant && !this.variant.available);

    triggers.forEach((trigger) => {
      trigger.hidden = !isSoldOut;
      trigger.disabled = !isSoldOut;
    });

    // Only ever hide add-to-cart when there is a waitlist trigger to take its place, otherwise a sold-out variant
    // would leave the shopper with no control at all.
    if (triggers.length) {
      this.addToCartButtons.forEach((button) => {
        button.hidden = isSoldOut;
      });
    }

    if (this.productName) {
      this.productName.textContent = this.dataset.productTitle;
    }

    if (this.variantName) {
      const hasVariantTitle = this.variant?.title && this.variant.title !== 'Default Title';
      this.variantName.textContent = hasVariantTitle ? this.variant.title : '';
      this.variantName.hidden = !hasVariantTitle;
    }

    if (this.variantImage) {
      const imageUrl = this.variant?.featured_image?.src || this.variant?.featured_media?.preview_image?.src || this.dataset.defaultImage;
      if (imageUrl) {
        this.variantImage.src = imageUrl;
        this.variantImage.alt = this.variant?.title && this.variant.title !== 'Default Title' ? `${this.dataset.productTitle} — ${this.variant.title}` : this.dataset.productTitle;
      }
    }

    if (changedVariant) this.resetForm();
    if (!isSoldOut && this.modal.open) this.modal.hide();
  }

  getVariants() {
    try {
      return JSON.parse(this.querySelector('[data-back-in-stock-variants]')?.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  getVariant(id) {
    return this.variants.find((variant) => String(variant.id) === String(id)) || null;
  }

  getVariantFromForm() {
    return this.getVariant(this.productForm?.querySelector('[name="id"]')?.value);
  }

  updateVariantById(id) {
    this.updateVariant(this.getVariant(id));
  }

  async submit(event) {
    event.preventDefault();
    this.clearMessage();
    this.updateVariant(this.getVariantFromForm());

    if (!this.variant?.id) {
      this.setMessage(this.dataset.selectOptionMessage, 'error');
      return;
    }

    if (!this.emailInput.checkValidity()) {
      this.emailInput.reportValidity();
      return;
    }

    this.submitButton.disabled = true;
    this.submitButton.setAttribute('aria-busy', 'true');

    let response;

    try {
      response = await fetch(this.dataset.endpoint, {
        method: 'POST',
        // text/plain keeps this a CORS "simple request", so the browser skips the OPTIONS preflight entirely.
        // The proxy builds the Klaviyo JSON:API envelope and holds the credential.
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ email: this.emailInput.value.trim(), variantId: this.variant.id })
      });
    } catch (error) {
      // fetch() only rejects when no response was ever received. Going through our own subdomain removed the
      // common cause of that - content blockers list a.klaviyo.com as a tracker and killed the old direct call -
      // so what remains is a genuinely offline shopper or the proxy being unreachable. Still not retryable
      // without something changing, so it keeps its own copy plus a manual route out.
      console.warn('[Back in stock] Request to the waitlist proxy never completed', error);
      this.setMessage(this.dataset.networkErrorMessage, 'error', true);
      this.submitButton.disabled = false;
      this.submitButton.removeAttribute('aria-busy');
      return;
    }

    try {
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error(body.error || `Waitlist proxy responded with ${response.status}`);
      }

      this.trackSubscription();
      this.setMessage(this.dataset.successMessage);
      this.emailInput.disabled = true;
      this.submitButton.disabled = true;
      this.submitButton.hidden = true;
    } catch (error) {
      // The proxy's error code is useful in the console but is not shopper-facing copy.
      console.warn('[Back in stock]', error);
      this.setMessage(this.dataset.errorMessage, 'error', true);
      this.submitButton.disabled = false;
    } finally {
      this.submitButton.removeAttribute('aria-busy');
    }
  }

  trackSubscription() {
    const variantTitle = this.variant?.title && this.variant.title !== 'Default Title'
      ? this.variant.title
      : 'Default';
    const eventData = {
      product_id: String(this.dataset.productId || this.variant?.product_id || ''),
      product_handle: this.dataset.productHandle || '',
      product_name: this.dataset.productTitle || '',
      variant_id: String(this.variant?.id || ''),
      variant_name: variantTitle
    };

    try {
      const shopifyPublish = window.Shopify?.analytics?.publish?.('jomo:back_in_stock_subscribed', eventData);
      shopifyPublish?.catch?.((error) => console.warn('[Back in stock analytics]', error));
    } catch (error) {
      console.warn('[Back in stock analytics]', error);
    }

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'back_in_stock_subscribed', eventData);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'back_in_stock_subscribed', ...eventData });
      }
    } catch (error) {
      console.warn('[Back in stock analytics]', error);
    }
  }

  resetForm() {
    if (this.emailInput) {
      this.emailInput.value = '';
      this.emailInput.disabled = false;
    }
    if (this.submitButton) this.submitButton.disabled = false;
    if (this.submitButton) this.submitButton.hidden = false;
    this.clearMessage();
  }

  buildFallbackHref() {
    const email = this.dataset.contactEmail;
    if (!email) return null;

    const variantTitle = this.variant?.title && this.variant.title !== 'Default Title' ? ` — ${this.variant.title}` : '';
    const product = `${this.dataset.productTitle}${variantTitle}`;
    const subject = `Waitlist request: ${product}`;
    const body = [
      `Please add me to the waitlist for ${product}.`,
      '',
      `Email: ${this.emailInput?.value.trim() || ''}`,
      `Product: ${window.location.href}`
    ].join('\n');

    return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  setMessage(message, status = 'success', showFallback = false) {
    this.messageText.textContent = message;
    this.message.hidden = false;
    this.message.classList.toggle('banner--success', status === 'success');
    this.message.classList.toggle('banner--error', status === 'error');
    this.successIcon.hidden = status !== 'success';

    if (this.fallbackLink) {
      const href = showFallback ? this.buildFallbackHref() : null;
      if (href) this.fallbackLink.href = href;
      this.fallbackLink.hidden = !href;
    }
  }

  clearMessage() {
    if (!this.message) return;
    this.messageText.textContent = '';
    this.message.hidden = true;
    this.message.classList.remove('banner--success', 'banner--error');
    this.successIcon.hidden = true;
    if (this.fallbackLink) this.fallbackLink.hidden = true;
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock);
}

// Keep the waitlist UI in sync even if a product form is reconnected or an
// app listens to and alters the theme event first. Variant events bubble from
// the product form, so this catches every product-page selection centrally.
function syncBackInStockForForm(form, variant) {
  if (!form?.id) return;

  document.querySelectorAll('back-in-stock').forEach((component) => {
    if (component.initialized && component.dataset.productForm === form.id) {
      component.updateVariant(variant || component.getVariantFromForm());
    }
  });
}

document.addEventListener('variant:change', (event) => {
  syncBackInStockForForm(event.target, event.detail?.variant);
});

document.addEventListener('change', (event) => {
  if (event.target.name === 'id') {
    syncBackInStockForForm(event.target.form);
  }
});

/**
 * Prestige 10 restructured the accordion into <accordion-disclosure><details>…</details></accordion-disclosure>,
 * but this theme (9.3) still registers "accordion-disclosure" as a customized built-in for <details is="…">, so a
 * bare <accordion-disclosure> tag is never upgraded. Descriptions authored in the 10.x shape therefore open with no
 * animation and never update aria-expanded, which is what drives the +/- icon in theme.css.
 *
 * This reproduces AccordionDisclosure so that markup behaves identically to a theme-rendered accordion. The
 * ":not(:defined)" guard means the shim disables itself as soon as a real <accordion-disclosure> element is
 * registered, so the whole block can be deleted once the theme is upgraded.
 */
const orphanAccordionSelector = 'accordion-disclosure:not(:defined) > details';
const orphanAccordionAnimations = new WeakMap();

function syncOrphanAccordion(details) {
  details.setAttribute('aria-expanded', details.open ? 'true' : 'false');
}

function cancelOrphanAccordionAnimations(details) {
  orphanAccordionAnimations.get(details)?.forEach((animation) => animation.cancel());
  orphanAccordionAnimations.delete(details);
}

/**
 * Mirrors the timings of the Motion timelines in theme.js: expanding eases the height over 250ms and fades the
 * content in over the last 150ms, collapsing fades the content out over 150ms while the height eases shut.
 */
function toggleOrphanAccordion(details, expand) {
  const summary = details.firstElementChild;
  const content = details.lastElementChild;

  // Measure before cancelling, so an interrupted animation continues from where it currently sits.
  const startHeight = details.getBoundingClientRect().height;
  cancelOrphanAccordionAnimations(details);

  if (expand) {
    details.open = true;
  }

  syncOrphanAccordion(details);

  const endHeight = expand ? details.scrollHeight : summary.clientHeight;
  details.style.overflow = 'hidden';

  const animations = [
    details.animate(
      [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
      { duration: 250, easing: 'ease', fill: 'forwards' }
    )
  ];

  if (content !== summary) {
    animations.push(
      expand
        ? content.animate(
            [
              { opacity: 0, transform: 'translateY(4px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ],
            // "backwards" holds the content hidden through the delay, the way the Motion timeline does.
            { duration: 150, delay: 150, easing: 'ease', fill: 'backwards' }
          )
        : content.animate([{ opacity: 0 }], { duration: 150, easing: 'ease', fill: 'forwards' })
    );
  }

  orphanAccordionAnimations.set(details, animations);

  Promise.all(animations.map((animation) => animation.finished))
    .then(() => {
      // Drop "open" before cancelling, so the element never renders a frame at its natural expanded height.
      if (!expand) {
        details.open = false;
      }

      cancelOrphanAccordionAnimations(details);
      details.style.overflow = '';
    })
    .catch(() => {}); // Superseded by a later toggle; that run owns the cleanup.
}

// Claim the click before the browser flips "open" itself, which is what leaves no room to animate. Enter and Space
// on a focused <summary> both dispatch a click, so keyboard operation keeps working.
document.addEventListener('click', (event) => {
  const summary = event.target.closest?.('summary');

  if (!summary || !summary.parentElement?.matches(orphanAccordionSelector)) {
    return;
  }

  event.preventDefault();
  toggleOrphanAccordion(summary.parentElement, !summary.parentElement.open);
});

// "toggle" does not bubble, so listen in the capture phase. Clicks are handled above, so this is only a safety net
// for "open" changing some other way, such as find-in-page expanding a collapsed panel.
document.addEventListener('toggle', (event) => {
  if (event.target.matches(orphanAccordionSelector)) {
    syncOrphanAccordion(event.target);
  }
}, true);

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(orphanAccordionSelector).forEach(syncOrphanAccordion);
});